import { render, staticRenderFns } from "./OwnershipTransfer.vue?vue&type=template&id=a53fa63e&"
import script from "./OwnershipTransfer.vue?vue&type=script&lang=js&"
export * from "./OwnershipTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports